/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import OrderCart from "../Component/OrderTracking/OrderCart";
import Layout from "../Component/Layout/Layout";
import BannerSection from "../Component/BannerSection";
import Button from "../Component/Button";
import { FaRegFileAlt } from "react-icons/fa";
import { FaTruckArrowRight } from "react-icons/fa6";
import OrderPosition from "../Component/OrderTracking/OrderPosition";
import OrderPaymentDetail from "../Component/OrderTracking/OrderPaymentDetail";
import { useLocation } from "react-router-dom";
import { axiosInstance } from "../Component/utils/axiosInstance";
import Loader from "../Component/Loader";

export default function TrackOrder() {
  const [searchId, setSearchId] = useState("");
  const [trackData, setTrackData] = useState([]);
  const [loading, setLoading] = useState(false);
  const trackId = useLocation();
  const date = new Date(trackData?.created_at);

  const formattedDate = `${date.getDate().toString().padStart(2, "0")}-${(
    date.getMonth() + 1
  )
    .toString()
    .padStart(2, "0")}-${date.getFullYear()}`;

  const getTrackData = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(
        `user/order/${trackId?.state ?? searchId}`
      );
      if (response?.data?.status === true) {
        setTrackData(response?.data?.order || []);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching track data:", error);
    }
  };
  useEffect(() => {
    if (trackId?.state) {
      getTrackData();
    }
  }, []);
  return (
    <Layout>
      <BannerSection
        heading="Track Your Order"
        description="Track Your Order"
      />
      {loading ? (
        <Loader />
      ) : trackData?.status ? (
        <div className="container">
          <div className="row align-items-center px-md-5">
            <div className="col-md-7 col-lg-7 col-12">
              <div className="d-flex align-items-center gap-4 justify-content-end">
                <p className="text-nowrap fs-3 fw-bolder">Order ID:</p>
                <input
                  className="form-conrtol text-nowrap fs-3 fw-bolder"
                  placeholder="3354654654526"
                  onChange={(e) => setSearchId(e?.target.value)}
                  style={{ border: 0 }}
                />
              </div>
            </div>
            <div className="col-md-4 col-lg-4 col-12  offset-md-1">
              <div className="d-flex align-items-center gap-4 justify-content-md-end justify-content-lg-end justify-content-center">
                {/* <Button
                label={"Invoice"}
                color={"#667085"}
                border={"1px solid #D0D5DD"}
                py={"2"}
                startIcon={<FaRegFileAlt />}
              /> */}
                <Button
                  label={"Track order"}
                  onClick={getTrackData}
                  color={"#fff"}
                  bg={"#CD2128"}
                  border={"1px solid #CD2128"}
                  py={"2"}
                  endIcon={<FaRegFileAlt />}
                />
              </div>
            </div>
            <div className="col-12 py-3 border-bottom">
              <p className="mb-0 fs-6 fw-semibold text-red">
                <FaTruckArrowRight /> Order date: {formattedDate}
              </p>
            </div>
            <OrderPosition status={trackData?.status ?? trackData?.status} />
          </div>
          {trackId ? (
            <div className="row pb-5">
              <div className="col-md-6 col-lg-6 col-12">
                {trackData?.order_products?.map((e, i) => (
                  <OrderCart e={e} i={i} />
                ))}
              </div>
              <div className="col-md-6 col-lg-5 offset-lg-1 col-12">
                <OrderPaymentDetail trackData={trackData} />
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      ) : (
        <div className="container py-4">
          <div className="row align-items-center px-md-5">
            <div className="col-md-7 col-lg-7 col-12">
              <div className="d-flex align-items-center gap-4 justify-content-end">
                <p className="text-nowrap fs-3 fw-bolder">Order ID:</p>
                <input
                  className="form-conrtol text-nowrap fs-3 fw-bolder"
                  placeholder="3354654654526"
                  onChange={(e) => setSearchId(e?.target.value)}
                  style={{ border: 0 }}
                />
              </div>
            </div>
            <div className="col-md-4 col-lg-4 col-12  offset-md-1">
              <div className="d-flex align-items-center gap-4 justify-content-md-end justify-content-lg-end justify-content-center">
                {/* <Button
                label={"Invoice"}
                color={"#667085"}
                border={"1px solid #D0D5DD"}
                py={"2"}
                startIcon={<FaRegFileAlt />}
              /> */}
                <Button
                  label={"Track order"}
                  onClick={getTrackData}
                  color={"#fff"}
                  bg={"#CD2128"}
                  border={"1px solid #CD2128"}
                  py={"2"}
                  endIcon={<FaRegFileAlt />}
                />
              </div>
            </div>
          </div>
          <h3 className="fw-bold py-4 text-center">
            Please Enter Your Tracking Id
          </h3>
          <OrderPosition status={trackData?.status ?? trackData?.status} />
        </div>
      )}
    </Layout>
  );
}
